import { apiAws } from "utils/hostname";
import { CountryType } from "types/Catalogs";

export const fetchCountries = async (): Promise<CountryType[]> => {
  try {
    const response = await await apiAws().get(
      "https://diswdgcu9cfva.cloudfront.net/countries/countries.json",
    );
    return response.data;
  } catch (error) {
    throw new Error("Fetch currencies error");
  }
};
